import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';

export default function PointOfContact({ venue, event }) {
  const { user } = useSelector((store) => store.users);

  const showDetails = user?.role?.id === 5 || user?.role?.id === 2;

  if (venue === undefined) {
    return false;
  }
  if (event === undefined) {
    return false;
  }

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={8}>
        <SimpleCard>
          <div style={{ marginLeft: 10 }}>
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
              <Typography variant="h6" fontWeight="bold" display="inline">
                Point of Contact:{' '}
              </Typography>
              <Typography variant="h7" marginTop={0} display="inline">
                Who will be the venue at this event?
              </Typography>
            </div>
            <Grid container>
              {/* <Grid item xs={6} md={8}></Grid> */}
              <Grid item xs={6} md={6}>
                <Typography>Name</Typography>
                <Typography color="#0997BA" fontWeight="bold">
                  {event?.contact_name}
                </Typography>
              </Grid>

              {showDetails && (
                <>
                  <Grid item xs={6} md={6}>
                    <Typography>Email</Typography>
                    <Typography color="#0997BA" fontWeight="bold">
                      {event?.contact_email}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Typography>Phone number</Typography>
                    <Typography color="#0997BA" fontWeight="bold">
                      {event?.contact_phone_number}
                    </Typography>
                  </Grid>
                </>
              )}

              <Grid item xs={6} md={6}>
                <Typography>Business</Typography>
                <Typography color="#0997BA" fontWeight="bold">
                  {venue?.business_type}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </SimpleCard>
      </Grid>
    </Grid>
  );
}

PointOfContact.propTypes = {
  venue: PropTypes.instanceOf(Object).isRequired,
  event: PropTypes.instanceOf(Object).isRequired,
};
